export default {
  addDouyinOrder: {
    name: "Douyin orders add api",
    version: 7,
    url: "jd/douyin/order",
    method: "POST",
  },
};
